<template>
  <div>
  <div class="bg-white p-4">
    <div class="row bg-primary p-3 rounded text-white">
      <div class="col-1">
        <icon :icon="['fad', 'thumbs-up']" class="fa-6x"/>
      </div>
      <div class="col d-flex">
        <h5 class="my-auto"> {{ wording[0].logout_submit.upload_successful }} </h5>
      </div>
    </div>
  </div>
  <div class="bg-white p-4">
    <div class="row bg-primary p-3 rounded text-white">
      <div class="col " v-html="wording[0].logout_submit.info">

      </div>
    </div>
  </div>
  </div>

</template>
<script>
import {mapState, mapActions} from 'vuex'

export default {
  data() {
    return {
      token: '',
      errorMsg: 'The entered token could not be verified, please try again or contact support.',
      showError: false,
      processing: false
    };
  },
  computed: mapState(["login", 'user', 'prefilledToken','wording']),
  mounted() {
    this.login.success = false;
    localStorage.removeItem('token');
    localStorage.removeItem('eposter-token');
    localStorage.removeItem('x-api-key');
  },
  methods: {
    ...mapActions(['CHECK_LOGIN']),
  }
}

</script>

<style scoped>

</style>
